import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './ep-pricing-esm-components-differential-price-for-quantity-differential-price-for-quantity.module.scss.js';
import { clsx } from './ep-pricing-esm-external-clsx-dist-clsx.js';
import { Typography, ErrorBoundary } from '@vp/swan';
import { useLocalization } from './ep-pricing-esm-hooks-useLocalizations.js';
import { DifferentialPriceInternal } from './ep-pricing-esm-components-differential-price-differential-price.component.js';
import { ZeroDisplayType } from './ep-pricing-esm-types-differential-price.types.js';

const DifferentialPriceForQuantityInternal = forwardRef(({ className, differentialPriceForQuantityConfig, ...rest }, ref) => {
  const { locale, currency, minimumFractionDigits, priceDifference, priceDifferenceDiscounted, quantity } = differentialPriceForQuantityConfig;
  const classNames = clsx(className, styles.differentialPriceForQuantity);
  const { t } = useLocalization(locale);
  if (!quantity) {
    return null;
  }
  const differentialPriceConfig = {
    locale,
    currency,
    minimumFractionDigits,
    priceDifference,
    priceDifferenceDiscounted,
    showComparativeDisplay: true,
    zeroDisplayType: ZeroDisplayType.Zero
  };
  return /* @__PURE__ */ jsx(Typography, { as: "span", ref, className: clsx(classNames), ...rest, children: t(quantity === 1 ? "differentialPrice.forUnit" : "differentialPrice.forUnits", {
    differentialPrice: /* @__PURE__ */ jsx(
      DifferentialPriceInternal,
      {
        className: clsx(classNames),
        fontWeight: !priceDifferenceDiscounted || priceDifferenceDiscounted >= priceDifference ? "bold" : "normal",
        differentialPriceConfig,
        placeholdertext: "Differential Price unavailable"
      }
    ),
    quantity
  }) });
});
const DifferentialPriceForQuantity = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(ErrorBoundary, { fallback: /* @__PURE__ */ jsx(Typography, { as: "span", children: props.placeholdertext }), children: /* @__PURE__ */ jsx(DifferentialPriceForQuantityInternal, { ...props, ref }) });
});

export { DifferentialPriceForQuantity, DifferentialPriceForQuantityInternal };
//# sourceMappingURL=ep-pricing-esm-components-differential-price-for-quantity-differential-price-for-quantity.component.js.map
